import React, { useState } from 'react';

import PaymentTopHeader from '@/pages/payment/components/PaymentTopHeader';
import PaymentFormSearch from '@/pages/payment/components/PaymentFormSearch';
import PaymentList from '@/pages/payment/components/PaymentList';

const PaymentPage: React.FC = () => {
  const [searchTrigger, setSearchTrigger] = useState(0);

  return (
    <>
      <PaymentTopHeader />
      <PaymentFormSearch onSearch={() => setSearchTrigger(prev => prev + 1)} />
      <PaymentList searchTrigger={searchTrigger}  />
    </>
  )
}

export default PaymentPage;